module.exports = __webpack_public_path__ + "static/media/info.83fc332b.svg";